import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Utils from '../../../util';
import { ProjectCommunicationService } from '../../../communication/project-comms.service';

@Component({
  selector: 'platform-picker-dialog',
  templateUrl: './platform-picker-dialog.component.html',
  styleUrls: [
    './platform-picker-dialog.component.scss'
  ]
})
export class PlatformPickerDialogComponent {
  constructor(public dialogRef: MatDialogRef<any>,
    private router: Router,
    private projectCommService: ProjectCommunicationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  title: string = '';
  trigger?: string;

  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    this.dialogRef.close(true);
  }

  canAccessADO() {
    return Utils.canAccessADO();
  }

  canAccessADM() {
    return Utils.canAccessADM();
  }

  canAccessADF() {
    return Utils.canAccessADF();
  }

  gotoADO() {
    this.router.navigate(['redirect'], { queryParams: { service: 'ado' } }).then(navigate => {
      if (navigate) this.projectCommService.unloadProject();
    });
  }

  gotoADM() {
    this.router.navigate(['redirect'], { queryParams: { service: 'adm' } }).then(navigate => {
      if (navigate) this.projectCommService.unloadProject();
    });
  }

  gotoADF() {
    this.router.navigate(['redirect'], { queryParams: { service: 'adf' } }).then(navigate => {
      if (navigate) this.projectCommService.unloadProject();
    });
  }

  /**
   * reads the account id from the local storage and appends it to the logo request in HTML
   * Custom headers are loaded using this info
   */
  getAccountID() {
    return localStorage.getItem('accountID');
  }

  closePlatformPicker() {
    this.dialogRef.close(null);
  }

  adoExpired() {
    return Utils.adoExpired();
  }

  admExpired() {
    return Utils.admExpired();
  }
}
